import { createBrowserRouter, Navigate, Outlet, ScrollRestoration } from 'react-router-dom';
import { EventListPage } from './pages/EventListPage';
import { EventDetailPage } from './pages/EventDetailPage';
import { CreateEventPage } from './pages/CreateEventPage';
import { CreateGroupPage } from './pages/CreateGroupPage';
import { CreateExpensePage } from './pages/CreateExpensePage';
import { EditExpensePage } from './pages/EditExpensePage';
import { ExpenseStepDetails } from './pages/expense-wizard/ExpenseStepDetails';
import { ExpenseStepParticipants } from './pages/expense-wizard/ExpenseStepParticipants';
import { NotFoundPage } from './pages/NotFoundPage';

function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <EventListPage />,
      },
      {
        path: '/event/new',
        element: <CreateEventPage />,
      },
      {
        path: '/event/:eventId',
        element: <Navigate to="participants" replace />,
      },
      {
        path: '/event/:eventId/groups/new',
        element: <CreateGroupPage />,
      },
      {
        path: '/event/:eventId/expenses/new',
        element: <CreateExpensePage />,
        children: [
          { path: 'step-1', element: <ExpenseStepDetails /> },
          { path: 'step-2', element: <ExpenseStepParticipants /> },
        ],
      },
      {
        path: '/event/:eventId/expenses/:expenseId/edit',
        element: <EditExpensePage />,
        children: [
          { path: 'step-1', element: <ExpenseStepDetails /> },
          { path: 'step-2', element: <ExpenseStepParticipants /> },
        ],
      },
      {
        path: '/event/:eventId/:tab',
        element: <EventDetailPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
